
import React from 'react';
import { LogOut, Eye } from 'lucide-react';

interface ImpersonationBannerProps {
  userName: string;
  onExit: () => void;
}

const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ userName, onExit }) => {
  return (
    <div className="sticky top-0 z-40 bg-gradient-to-r from-amber-500 to-orange-500 border-b-2 border-orange-600 shadow-lg">
      <div className="px-4 md:px-8 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-white/20 p-2">
              <Eye className="h-5 w-5 text-white" />
            </div>
            <div>
              <p className="text-sm font-bold text-white">
                Anzeige als Benutzer: <span className="underline">{userName}</span>
              </p>
              <p className="text-xs text-amber-50">
                Sie sehen jetzt die Ansicht und Anfragen dieses Benutzers
              </p>
            </div>
          </div>
          <button
            onClick={onExit}
            className="flex items-center gap-2 rounded-xl bg-white px-4 py-2 text-sm font-bold text-orange-600 shadow-md hover:bg-amber-50 transition-all"
          >
            <LogOut className="h-4 w-4" />
            Ansicht beenden
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
